import styled from 'styled-components';

export const StyleContent = styled.div`
  min-height: 600px;
  background-color: #f0f2f5;
`;
